import React from "react";
import "./style.css";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";

const Technology = () => {
  return (
    <div>
      <Header />
      <Footer />
    </div>
  );
};

export default Technology;
